module.exports = __webpack_public_path__ + "static/media/sidenav-icon-upload.8e5e1264.svg";